(function () {
  const POLL_INTERVAL_MS = 500;
  const MAX_POLL_MS = 15000;

  function buildAddressBody({ zip, country, province }) {
    const params = new URLSearchParams();
    if (zip) params.append("shipping_address[zip]", zip);
    if (country) params.append("shipping_address[country]", country);
    if (province) params.append("shipping_address[province]", province);
    return params.toString();
  }

  function genericError() {
    return (window.shipping && window.shipping.wrong_message) || "Unable to fetch shipping rates";
  }

  async function prepare(body) {
    const response = await fetch("/cart/prepare_shipping_rates.json", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });
    if (response.status === 422) {
      const data = await response.json().catch(() => ({}));
      const fieldMessages = data && data.errors ? Object.values(data.errors).flat().join(", ") : "";
      throw new Error(fieldMessages || genericError());
    }
    if (!response.ok) {
      throw new Error(genericError());
    }
  }

  async function pollOnce(query) {
    const response = await fetch(`/cart/async_shipping_rates.json?${query}`);
    if (!response.ok) {
      throw new Error(genericError());
    }
    return response.json();
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function fetchShippingRatesAsync(address) {
    const query = buildAddressBody(address);
    await prepare(query);

    const start = Date.now();
    while (Date.now() - start < MAX_POLL_MS) {
      const data = await pollOnce(query);
      if (data && Array.isArray(data.shipping_rates)) {
        return data;
      }
      await delay(POLL_INTERVAL_MS);
    }
    throw new Error(genericError());
  }

  window.fetchShippingRatesAsync = fetchShippingRatesAsync;
})();
